import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getJobAppliedList } from "../../../../../redux/job/action";
import ListLoader from "../../../../CustomComponents/AllLoader/ListLoader";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import { formatNumberWithCommas } from "../../../../Common/AllDateTimeReleventFormate";
import GetPricewitoutlabel from "../../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetPricewitoutlabel";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import { PAGE_SIZE } from "../../../../../redux/constants";
import { getPostPaginationList } from "../../../../../redux/project/action";
import OrderPostPagination from "../../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";

export default function DeclinedJobs() {
  const { setManageAppliedjobroute } = useRouteBaseStateContext();

  const path = "Assets/scss/myorders.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  // const listdata?.response = useSelector(
  //   ({ job: { listdata?.response } }) => listdata?.response,
  // );
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getJobAppliedList(3));
  // }, []);

  const [listdata, setListdata] = useState("")
  const [pageNumber, setPageNumber] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    const data = {
      type: 3,
      index: pageNumber,
      size: PAGE_SIZE,
      declined: 1
    }
    if (data) {
      dispatch(getPostPaginationList(data)).then((res) => {
        setListdata(res)
      })
    }

  }, [pageNumber]);

  return (
    <div className="order-tabs">
      <div className="tab-content">
        <div className="posted-project">
          {Array.isArray(listdata?.response) && (
            <>
              <h4>Part time Job (PTJ)</h4>
              <OrderPostPagination
                totalitemcounts={listdata?.count?.declined_count}
                size={PAGE_SIZE}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
              />
              {listdata?.response?.length == 0 && <PostNotFound title={"No Post Found"} />}
              <div className="recent-post row recent-job">
                {listdata?.response.slice(0, 10).map((item, index) => (
                  <div className="col-md-6" key={index}
                    onClick={() => {
                      navigate(`/${lan}/dashboard/managework/jobs/applied/${item.id}`);
                      setManageAppliedjobroute("");
                    }}>
                    <div className="post-back recent-back recent-first">
                      <div className="recent-detail">
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/myorders/jobtype.svg`}
                            alt=""
                          />
                          Job type:
                          {item?.work_location == 1
                            ? "Virtual"
                            : item?.work_location == 2
                              ? "Physical"
                              : ""}
                        </p>
                        <h3>{item?.title}</h3>
                        <h1>
                          <GetPricewitoutlabel
                            type={item?.type}
                            price={item?.price}
                            price2={item?.price2}
                            hiring_type={item?.hiring_type}
                          />
                        </h1>
                      </div>
                      <div className="recent-detail">
                        <p>Proposals</p>
                        <h3>{item?.proposal_count} Applicants</h3>
                      </div>
                      <button
                        onClick={() => {
                          navigate(
                            `/${lan}/dashboard/managework/jobs/applied/${item.id}`,
                          );
                          setManageAppliedjobroute("");
                        }}
                        className="btn"
                      >
                        View details
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
